jQuery(function ($) {
    var _t = window.ProfileI18n || {};
    // Use global shared function from main.js if available, otherwise fallback to local
    const loadValidationScript = window.loadValidationScript || function(callback) {
        if (window.InputValidator) {
            if (typeof callback === 'function') callback();
        } else if (window._validationScriptLoading) {
            const checkInterval = setInterval(function() {
                if (window.InputValidator) {
                    clearInterval(checkInterval);
                    delete window._validationScriptLoading;
                    if (typeof callback === 'function') callback();
                }
            }, 50);
        } else {
            window._validationScriptLoading = true;
            $.getScript("/assets/frontend/js/validation.js", function() {
                delete window._validationScriptLoading;
                if (typeof callback === 'function') callback();
            });
        }
    };
    
    loadValidationScript(function () {

        const profileCommonParent = $("body");

        // FLASH MESSAGE AUTO-HIDE
        // Auto-hide success messages after 10 seconds
        const successMessages = $('.alert-success');
        successMessages.each(function() {
            const $message = $(this);
            setTimeout(function() {
                $message.css('transition', 'opacity 0.5s ease-out');
                $message.css('opacity', '0');
                setTimeout(function() {
                    $message.remove();
                }, 500);
            }, 10000);
        });
        // END FLASH MESSAGE AUTO-HIDE

        // PROFILE ADVERTISEMENTS SELECTIZE
        // Delay initialization to ensure no conflicts with other scripts
        setTimeout(function() {
            const profileSortingSelect = $('.profile-dashboard-sorting-selectize');
            if (profileSortingSelect.length > 0) {
                // Check if already initialized and destroy if needed
                if (profileSortingSelect[0].selectize) {
                    profileSortingSelect[0].selectize.destroy();
                }
                
                try {
                    profileSortingSelect.selectize({
                        onChange: function (value) {
                            if (value) {
                                sortAdvertisements(value);
                            }
                        }
                    });
                } catch (error) {
                    console.error('Error initializing profile dashboard sorting selectize:', error);
                }
            }
        }, 500); // 500ms delay
        
        profileCommonParent.on("click", ".profile-dashboard-sorting-wrapper .profile-sorting-filter-icon", function () {
            const selectize = $(this).siblings('select.profile-dashboard-sorting-selectize').selectize();
            if (selectize && selectize[0] && selectize[0].selectize) {
                selectize[0].selectize.open();
            }
        });
        // END PROFILE ADVERTISEMENTS SELECTIZE

        // PROFILE BACKGROUND IMAGE UPLOAD
        profileCommonParent.on("change", "#profile-background-input", function(e) {
            const file = e.target.files[0];
            if (!file) return;

            // Validate file type (including HEIC which may not be detected by some browsers)
            const fileName = file.name.toLowerCase();
            const isHeic = fileName.endsWith('.heic') || fileName.endsWith('.heif');
            if (!file.type.startsWith('image/') && !isHeic) {
                // Use jQuery to show error in a more user-friendly way
                const errorMsg = $('<div class="alert alert-danger mt-2"></div>').text(_t.imageSelectError || 'Please select an image');
                $(e.target).after(errorMsg);
                setTimeout(() => errorMsg.fadeOut(), 3000);
                return;
            }

            // Validate file size (max 20MB)
            if (file.size > 20 * 1024 * 1024) {
                // Use jQuery to show error in a more user-friendly way
                const errorMsg = $('<div class="alert alert-danger mt-2"></div>').text(_t.imageSizeError || 'Image size must not exceed 20MB');
                $(e.target).after(errorMsg);
                setTimeout(() => errorMsg.fadeOut(), 3000);
                return;
            }

            const reader = new FileReader();
            reader.onload = function(e) {
                const img = new Image();
                img.onload = function() {
                    // Create canvas for resizing
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    
                    // Set canvas size (max 1920x1080)
                    const maxWidth = 1920;
                    const maxHeight = 1080;
                    let { width, height } = img;
                    
                    if (width > maxWidth) {
                        height = (height * maxWidth) / width;
                        width = maxWidth;
                    }
                    if (height > maxHeight) {
                        width = (width * maxHeight) / height;
                        height = maxHeight;
                    }
                    
                    canvas.width = width;
                    canvas.height = height;
                    
                    // Draw resized image
                    ctx.drawImage(img, 0, 0, width, height);

                    // Convert to WebP Blob
                    canvas.toBlob(function(blob) {
                        // Preview the resized image
                        const previewUrl = URL.createObjectURL(blob);
                        $('.hero-profile-background').attr('src', previewUrl).removeClass('d-none');

                        // AJAX upload to backend
                        let formData = new FormData();
                        formData.append('profile_background', blob, 'background.webp');
                        
                        // csrfSafeAjaxPost will fetch fresh token and inject it automatically
                        csrfSafeAjaxPost(
                            '/profile/uploadProfileBackground',
                            formData,
                            function(response) {
                                if (response.success) {
                                    // Optionally update the preview with the returned image_url
                                    $('.hero-profile-background').attr('src', response.image_url);
                                } else {
                                    // Use jQuery notification instead of alert
                                    const errorMsg = $('<div class="alert alert-danger mt-2"></div>').text((_t.imageUploadError || 'Error uploading image.') + ' ' + response.message);
                                    $('body').append(errorMsg);
                                    setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 5000);
                                }
                            },
                            function(xhr) {
                                // Use jQuery notification instead of alert
                                const errorMsg = $('<div class="alert alert-danger mt-2"></div>').text(_t.imageUploadError || 'Error uploading image.');
                                $('body').append(errorMsg);
                                setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 5000);
                            }
                        );
                    }, 'image/webp', 0.9);
                };
                img.onerror = function () {
                    // Use jQuery notification instead of alert
                    const errorMsg = $('<div class="alert alert-danger mt-2"></div>').text(_t.imageReadError || 'Could not read image.');
                    $('body').append(errorMsg);
                    setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 5000);
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        });

        // PROFILE IMAGE UPLOAD
        profileCommonParent.on("change", "#profile-image-input", function(e) {
            const file = e.target.files[0];
            if (!file) return;

            // Validate file type (including HEIC which may not be detected by some browsers)
            const fileName = file.name.toLowerCase();
            const isHeic = fileName.endsWith('.heic') || fileName.endsWith('.heif');
            if (!file.type.startsWith('image/') && !isHeic) {
                // Use jQuery to show error in a more user-friendly way
                const errorMsg = $('<div class="alert alert-danger mt-2"></div>').text(_t.imageSelectError || 'Please select an image');
                $(e.target).after(errorMsg);
                setTimeout(() => errorMsg.fadeOut(), 3000);
                return;
            }

            // Validate file size (max 20MB)
            if (file.size > 20 * 1024 * 1024) {
                // Use jQuery to show error in a more user-friendly way
                const errorMsg = $('<div class="alert alert-danger mt-2"></div>').text(_t.imageSizeError || 'Image size must not exceed 20MB');
                $(e.target).after(errorMsg);
                setTimeout(() => errorMsg.fadeOut(), 3000);
                return;
            }

            const reader = new FileReader();
            reader.onload = function(e) {
                const img = new Image();
                img.onload = function() {
                    // Create canvas for resizing
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    
                    // Set canvas size (max 400x400 for profile image)
                    const maxSize = 400;
                    let { width, height } = img;
                    
                    if (width > maxSize || height > maxSize) {
                        if (width > height) {
                            height = (height * maxSize) / width;
                            width = maxSize;
                        } else {
                            width = (width * maxSize) / height;
                            height = maxSize;
                        }
                    }
                    
                    canvas.width = width;
                    canvas.height = height;
                    
                    // Draw resized image
                    ctx.drawImage(img, 0, 0, width, height);

                    // Convert to WebP Blob
                    canvas.toBlob(function(blob) {
                        // Preview the resized image
                        const previewUrl = URL.createObjectURL(blob);
                        $('.hero-profile-image').attr('src', previewUrl);

                        // AJAX upload to backend
                        let formData = new FormData();
                        formData.append('profile_image', blob, 'profile.webp');
                        
                        // csrfSafeAjaxPost will fetch fresh token and inject it automatically
                        csrfSafeAjaxPost(
                            '/profile/uploadProfileImage',
                            formData,
                            function(response) {
                                if (response.success) {
                                    // Optionally update the preview with the returned image_url
                                    $('.hero-profile-image').attr('src', response.image_url);
                                } else {
                                    // Use jQuery notification instead of alert
                                    const errorMsg = $('<div class="alert alert-danger mt-2"></div>').text((_t.imageUploadError || 'Error uploading image.') + ' ' + response.message);
                                    $('body').append(errorMsg);
                                    setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 5000);
                                }
                            },
                            function(xhr) {
                                // Use jQuery notification instead of alert
                                const errorMsg = $('<div class="alert alert-danger mt-2"></div>').text(_t.imageUploadError || 'Error uploading image.');
                                $('body').append(errorMsg);
                                setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 5000);
                            }
                        );
                    }, 'image/webp', 0.9);
                };
                img.onerror = function () {
                    // Use jQuery notification instead of alert
                    const errorMsg = $('<div class="alert alert-danger mt-2"></div>').text(_t.imageReadError || 'Could not read image.');
                    $('body').append(errorMsg);
                    setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 5000);
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        });

        // PROFILE DASHBOARD TAB BUTTONS (AJAX LOADING)
        function getLoadAdsEndpoint() {
            return $('.profile-common-content').attr('data-load-ads-url') || '/profile/load-ads';
        }
        function getSortAdsEndpoint() {
            return $('.profile-common-content').attr('data-sort-ads-url') || '/profile/sort-ads';
        }
        function getMoveAdEndpoint() {
            return $('.profile-common-content').attr('data-move-ad-url') || '/profile/move-ad';
        }
        function getAdDeleteFeedbackEndpoint() {
            return $('.profile-common-content').attr('data-ad-delete-feedback-url') || '/profile/ad-delete-feedback';
        }
        function getGoogleReviewUrl() {
            return $('.profile-common-content').attr('data-google-review-url') || '';
        }
        function getUpdatePriceEndpoint() {
            return $('.profile-common-content').attr('data-update-price-url') || '/profile/update-price';
        }
        function getPriceHistoryEndpoint() {
            return $('.profile-common-content').attr('data-price-history-url') || '/profile/price-history';
        }
        function getQuickPriceI18n() {
            const $content = $('.profile-common-content').first();
            return {
                errorGeneric: $content.attr('data-i18n-quick-price-error-generic') || 'Failed to save price.',
                errorEnterPrice: $content.attr('data-i18n-quick-price-error-enter-price') || 'Enter a price.',
                errorMissingCarId: $content.attr('data-i18n-quick-price-error-missing-car-id') || 'Advertisement ID not found.'
            };
        }
        const quickPriceI18n = getQuickPriceI18n();
        function getPriceHistoryI18n() {
            const $content = $('.profile-common-content').first();
            return {
                title: $content.attr('data-i18n-price-history-title') || 'Price history',
                loading: $content.attr('data-i18n-price-history-loading') || 'Loading...',
                empty: $content.attr('data-i18n-price-history-empty') || 'No price changes yet.',
                loadMore: $content.attr('data-i18n-price-history-load-more') || 'Load more',
                close: $content.attr('data-i18n-price-history-close') || 'Close',
                error: $content.attr('data-i18n-price-history-error') || 'Failed to load price history.'
            };
        }
        const priceHistoryI18n = getPriceHistoryI18n();

        // Outcome modal after a published ad leaves the market
        const $deleteOutcomeModal = $('#adDeletionOutcomeModal');
        const deleteOutcomeSubmitText = ($('#cbDeleteOutcomeSubmit').text() || '').trim();
        let deleteOutcomeState = {
            token: '',
            outcome: '',
            carTitle: '',
            submitted: false,
            saving: false,
            allowClose: false,
            reviewPromptOffered: false,
            reviewCtaClicked: false
        };

        function trackReviewFunnelEvent(eventName, extra) {
            if (!window.CarBuyAnalytics || typeof window.CarBuyAnalytics.track !== 'function') {
                return;
            }
            const payload = Object.assign({
                surface: 'web',
                channel: 'google_review',
                trigger: 'sold_platform'
            }, extra || {});
            window.CarBuyAnalytics.track(eventName, payload);
        }

        function trackAdOutcomeEvent(eventName, extra) {
            if (!window.CarBuyAnalytics || typeof window.CarBuyAnalytics.track !== 'function') {
                return;
            }
            window.CarBuyAnalytics.track(eventName, Object.assign({
                surface: 'web'
            }, extra || {}));
        }

        function resetDeleteOutcomeModal() {
            deleteOutcomeState = {
                token: '',
                outcome: '',
                carTitle: '',
                submitted: false,
                saving: false,
                allowClose: false,
                reviewPromptOffered: false,
                reviewCtaClicked: false
            };
            if (!$deleteOutcomeModal.length) return;
            $deleteOutcomeModal.find('[data-role="car-title"]').text('');
            $deleteOutcomeModal.find('.cb-delete-outcome-option').removeClass('active');
            $deleteOutcomeModal.find('.cb-delete-outcome-options, .cb-delete-outcome-desc').removeClass('d-none');
            $deleteOutcomeModal.find('.cb-delete-outcome-review').addClass('d-none');
            $('#cbDeleteOutcomeSubmit')
                .removeClass('d-none')
                .prop('disabled', true)
                .text(deleteOutcomeSubmitText);
        }

        function dismissDeleteOutcomeReviewPrompt() {
            if (deleteOutcomeState.reviewCtaClicked || !deleteOutcomeState.reviewPromptOffered) {
                return;
            }
            trackReviewFunnelEvent('review_prompt_dismissed');
        }

        function openDeleteOutcomeModal(feedback) {
            if (!$deleteOutcomeModal.length || !feedback || !feedback.token) return;

            deleteOutcomeState.token = String(feedback.token || '');
            deleteOutcomeState.carTitle = String(feedback.car_title || '');
            deleteOutcomeState.outcome = '';
            deleteOutcomeState.submitted = false;
            deleteOutcomeState.saving = false;
            deleteOutcomeState.allowClose = false;
            deleteOutcomeState.reviewPromptOffered = false;
            deleteOutcomeState.reviewCtaClicked = false;

            $deleteOutcomeModal.find('[data-role="car-title"]').text(deleteOutcomeState.carTitle || '');
            $deleteOutcomeModal.find('.cb-delete-outcome-option').removeClass('active');
            $deleteOutcomeModal.find('.cb-delete-outcome-review').addClass('d-none');
            $('#cbDeleteOutcomeSubmit').prop('disabled', true);

            // Prepare Google review link (fallback to Google search if not configured)
            const configured = getGoogleReviewUrl();
            const fallback = 'https://www.google.com/search?q=' + encodeURIComponent('carbuy.lv atsauksmes');
            const reviewUrl = configured && configured.trim() ? configured.trim() : fallback;
            $deleteOutcomeModal.find('[data-role="review-link"]').attr('href', reviewUrl);

            trackAdOutcomeEvent('ad_outcome_prompted');
            $deleteOutcomeModal.modal('show');
        }

        function saveDeleteOutcome(outcome, onSuccess, onFailure) {
            if (!deleteOutcomeState.token || deleteOutcomeState.saving) return;
            deleteOutcomeState.saving = true;

            const formData = new FormData();
            formData.append('token', deleteOutcomeState.token);
            formData.append('outcome', outcome);

            csrfSafeAjaxPost(
                getAdDeleteFeedbackEndpoint(),
                formData,
                function(response) {
                    deleteOutcomeState.saving = false;
                    if (!response || !response.success) {
                        if (typeof onFailure === 'function') onFailure();
                        return;
                    }
                    deleteOutcomeState.submitted = true;
                    trackAdOutcomeEvent(
                        outcome === 'skipped' ? 'ad_outcome_skipped' : 'ad_outcome_saved',
                        outcome === 'skipped' ? {} : { outcome: outcome }
                    );
                    if (typeof onSuccess === 'function') onSuccess(response);
                },
                function() {
                    deleteOutcomeState.saving = false;
                    if (typeof onFailure === 'function') onFailure();
                }
            );
        }

        function showDeleteOutcomeSaveError() {
            const errMsg = $('<div class="alert alert-danger mt-2"></div>').text(_t.saveError || 'Error saving. Please try again.');
            $deleteOutcomeModal.find('.modal-body').prepend(errMsg);
            setTimeout(() => errMsg.fadeOut(() => errMsg.remove()), 5000);
        }

        function closeDeleteOutcomeAfterSave() {
            deleteOutcomeState.allowClose = true;
            $deleteOutcomeModal.modal('hide');
        }

        function saveSkippedOutcome() {
            saveDeleteOutcome('skipped', closeDeleteOutcomeAfterSave, showDeleteOutcomeSaveError);
        }

        if ($deleteOutcomeModal.length) {
            $deleteOutcomeModal.on('click', '.cb-delete-outcome-option', function () {
                const $btn = $(this);
                const outcome = String($btn.data('outcome') || '').toLowerCase();
                if (!outcome) return;

                deleteOutcomeState.outcome = outcome;
                $deleteOutcomeModal.find('.cb-delete-outcome-option').removeClass('active');
                $btn.addClass('active');
                $('#cbDeleteOutcomeSubmit').prop('disabled', false);
            });

            $deleteOutcomeModal.on('click', '[data-role="review-link"]', function () {
                deleteOutcomeState.reviewCtaClicked = true;
                trackReviewFunnelEvent('review_cta_clicked');
            });

            $deleteOutcomeModal.on('hide.bs.modal', function (event) {
                if (!deleteOutcomeState.allowClose && !deleteOutcomeState.submitted && deleteOutcomeState.token) {
                    event.preventDefault();
                    saveSkippedOutcome();
                }
            });

            $deleteOutcomeModal.on('hidden.bs.modal', function () {
                dismissDeleteOutcomeReviewPrompt();
                resetDeleteOutcomeModal();
            });

            $('#cbDeleteOutcomeSubmit').on('click', function () {
                if (!deleteOutcomeState.token || !deleteOutcomeState.outcome) return;

                const $btn = $(this);
                const originalText = $btn.text();
                $btn.prop('disabled', true).text('...');

                saveDeleteOutcome(
                    deleteOutcomeState.outcome,
                    function(response) {
                        if (deleteOutcomeState.outcome === 'sold_platform') {
                            $deleteOutcomeModal.find('.cb-delete-outcome-options, .cb-delete-outcome-desc').addClass('d-none');
                            $deleteOutcomeModal.find('.cb-delete-outcome-review').removeClass('d-none');
                            $btn.addClass('d-none');
                            if (!deleteOutcomeState.reviewPromptOffered) {
                                deleteOutcomeState.reviewPromptOffered = true;
                                trackReviewFunnelEvent('review_prompt_offered');
                            }
                            return;
                        }
                        closeDeleteOutcomeAfterSave();
                    },
                    function() {
                        $btn.prop('disabled', false).text(originalText);
                        showDeleteOutcomeSaveError();
                    }
                );
            });
        }
        function getSectionFromUrl() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('section')) {
                return urlParams.get('section') || 'active';
            }
            if (urlParams.has('drafts')) return 'drafts';
            if (urlParams.has('archive')) return 'archive';
            if (urlParams.has('active')) return 'active';
            return 'active';
        }

        profileCommonParent.on("click", ".profile-tab-button", function (e) {
            e.preventDefault();
            
            const $button = $(this);
            const section = $button.data('section');
            
            // Don't reload if already active
            if ($button.hasClass('active-description')) {
                return;
            }
            
            // Update active button
            $('.profile-tab-button').removeClass('active-description');
            $button.addClass('active-description');
            
            // Update URL without page reload - use section name directly
            const baseUrl = window.location.pathname.split('?')[0];
            const newUrl = baseUrl + (section === 'active' ? '' : '?' + section);
            window.history.pushState({section: section}, '', newUrl);
            
            // Load content
            loadSectionContent(section);
        });

        // Function to load section content
        function loadSectionContent(section) {
            // Show loading indicator
            showLoading();
            
            // Make AJAX request
            $.ajax({
                url: getLoadAdsEndpoint(),
                method: 'GET',
                data: {
                    section: section
                },
                success: function(response) {
                    if (response.success) {
                        // Update the advertisements content
                        updateAdvertisementsContent(response.html);
                        
                        // Update page title based on section
                        updatePageTitle(section);
                    } else {
                        showError(_t.adLoadError || 'Error loading ads');
                    }
                },
                error: function(xhr, status, error) {
                    showError(_t.adLoadError || 'Error loading ads');
                },
                complete: function() {
                    // Hide loading indicator
                    hideLoading();
                }
            });
        }

        // Function to show loading indicator
        function showLoading() {
            // Use existing preloader
            $('.preloader').show();
        }

        // Function to hide loading indicator
        function hideLoading() {
            // Use existing preloader
            $('.preloader').hide();
        }

        // Function to update advertisements content
        function updateAdvertisementsContent(html) {
            // Replace the advertisements section
            $('.profile-advertisements, .profile-no-advertisements').remove();
            
            const $container = $('.profile-common-content');
            $container.append(html);
        }

        // Function to update page title
        var _initialTitle = document.title;
        function updatePageTitle(section) {
            document.title = _initialTitle;
        }

        // Function to show error message
        function showError(message) {
            // Use jQuery notification instead of alert
            const errorMsg = $('<div class="alert alert-danger mt-2"></div>').text(message);
            $('body').append(errorMsg);
            setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 5000);
        }

        // Handle browser back/forward buttons
        window.addEventListener('popstate', function(event) {
            const section = getSectionFromUrl();
            
            // Update active button
            $('.profile-tab-button').removeClass('active-description');
            $('.profile-tab-button[data-section="' + section + '"]').addClass('active-description');
            
            // Load content for the section
            loadSectionContent(section);
        });

        // If URL has ?drafts (or similar), load that section on initial page load
        const initialSection = getSectionFromUrl();
        if (initialSection && initialSection !== 'active') {
            $('.profile-tab-button').removeClass('active-description');
            $('.profile-tab-button[data-section="' + initialSection + '"]').addClass('active-description');
            loadSectionContent(initialSection);
        }

        // PROFILE SETTINGS FORM HANDLING
        let formRunner = true;

        profileCommonParent.on("submit", "#profile-settings-form", function (e) {
            e.preventDefault();
            
            if (formRunner === true) {
                formRunner = false;
                
                const form = $(this);
                const submitBtn = $('.application-button');
                const messageDiv = $('#settings-message');
                
                // Clear previous errors
                $('.error-message').empty();
                messageDiv.empty();
                
                // Disable submit button
                submitBtn.prop('disabled', true).text(_t.settingsSaving || 'Saving...');
                
                // Create FormData object from the form
                let formData = new FormData(form[0]);
                
                // csrfSafeAjaxPost will fetch fresh token and inject it automatically
                csrfSafeAjaxPost(
                    '/profile/save-profile',
                    formData,
                    function(response) {
                        formRunner = true;

                        if (response.success === false) {
                            // Show validation errors
                            if (response.errors) {
                                Object.keys(response.errors).forEach(function(field) {
                                    const errorDiv = $('#' + field + '-error');
                                    if (errorDiv.length) {
                                        errorDiv.html('<span class="text-danger">' + $('<div>').text(response.errors[field]).html() + '</span>');
                                    }
                                });
                            }
                            
                            if (response.message) {
                                if (response.success === false) {
                                    messageDiv.html('<div class="alert alert-danger">' + $('<div>').text(response.message).html() + '</div>');
                                } else {
                                    messageDiv.html('<div class="alert alert-success">' + $('<div>').text(response.message).html() + '</div>');
                                }
                            }
                        } else if (response.success === true) {
                            messageDiv.html('<div class="alert alert-success">' + response.message + '</div>');
                        }
                    },
                    function(xhr, status, error) {
                        formRunner = true;
                        
                        // Always try to update CSRF token first, regardless of error type
                        if (xhr.responseJSON && xhr.responseJSON.csrf_hash) {
                            window.CSRFHelper.updateCSRFMeta(xhr.responseJSON);
                        }
                        
                        if (xhr.status === 403) {
                            $.get('/ajax/get-csrf-token', function(response) {
                                window.CSRFHelper.updateCSRFMeta(response);
                            });
                            messageDiv.html('<div class="alert alert-danger">' + (_t.sessionExpired || 'Session expired. Please try again.') + '</div>');
                        } else {
                            messageDiv.html('<div class="alert alert-danger">' + (_t.settingsSaveError || 'Error saving settings. Please try again.') + '</div>');
                        }
                    },
                    function(xhr) {
                        if (xhr && xhr.responseJSON && xhr.responseJSON.csrf_hash) {
                            window.CSRFHelper.updateCSRFMeta(xhr.responseJSON);
                        }
                        submitBtn.prop('disabled', false).text(_t.settingsSaveBtn || 'Save');
                    }
                );
            }
        });
        // END PROFILE SETTINGS FORM HANDLING

        // FORGOT PASSWORD FORM HANDLING
        let forgotFormRunner = true;

        profileCommonParent.on("submit", ".reset-password-form", function (e) {
            e.preventDefault();

            if (forgotFormRunner === true) {
                forgotFormRunner = false;

                const form = $(this);
                const submitBtn = form.find('.reset-password-button');
                const messageDiv = form.find('.reset-password-success-submit');

                // Clear previous messages
                messageDiv.removeClass('d-none').empty();

                // Disable submit button and show loading
                submitBtn.prop('disabled', true).text(_t.sending || 'Sending...');

                // Create FormData object from the form
                let formData = new FormData(form[0]);

                        csrfSafeAjaxPost(
                            '/profile/forgot',
                            formData,
                            function(response) {
                                forgotFormRunner = true;

                                if (response.success === true) {
                                    form.addClass('d-none');
                                    messageDiv.html('<span class="text-success-custom">Super!</span><br>' + response.message);
                                } else {
                                    if (response.message) {
                                        const errorMsg = $('<div class="alert alert-danger mt-2"></div>').text(response.message);
                                        form.after(errorMsg);
                                        setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 5000);
                                    } else {
                                        const errorMsg = $('<div class="alert alert-danger mt-2"></div>').text(_t.sendError || 'Error sending request. Please try again.');
                                        form.after(errorMsg);
                                        setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 5000);
                                    }
                                }
                            },
                            function(xhr, status, error) {
                                forgotFormRunner = true;

                                if (xhr.status === 403) {
                                    const errorMsg = $('<div class="alert alert-warning mt-2"></div>').text(_t.sendErrorRetry || 'Session expired. Please reload the page and try again.');
                                    form.after(errorMsg);
                                    setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 3000);
                                } else {
                                    const errorMsg = $('<div class="alert alert-danger mt-2"></div>').text(_t.sendError || 'Error sending request. Please try again.');
                                    form.after(errorMsg);
                                    setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 5000);
                                }
                            },
                            function(xhr) {
                                submitBtn.prop('disabled', false).text(submitBtn.data('original-text') || 'Submit');
                            }
                        );
            }
        });
        // END FORGOT PASSWORD FORM HANDLING

        // Function to sort advertisements
        function sortAdvertisements(sortBy) {
            // Get current section from URL (supports ?drafts) or active button
            let section = getSectionFromUrl();
            
            // If no section in URL, get from active button
            if (!section) {
                const activeButton = $('.profile-tab-button.active-description');
                if (activeButton.length) {
                    section = activeButton.data('section');
                } else {
                    section = 'active'; // Default to active
                }
            }
            
            // Show loading indicator
            showLoading();

            // Prepare form data
            let formData = new FormData();
            formData.append('sort', sortBy);
            formData.append('section', section);
            
            // Inject CSRF token
            formData = window.CSRFHelper.injectCSRF(formData);

            // Debug: Check if CSRF token was injected
            const csrfData = window.CSRFHelper.getCSRFData();
            console.log('CSRF injection check:', {
                csrfName: csrfData.name,
                csrfValue: csrfData.value,
                formDataHasToken: formData.has(csrfData.name)
            });

            // Make AJAX request
            $.ajax({
                url: getSortAdsEndpoint(),
                method: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: function(response) {
                    
                    // Always update CSRF token first
                    window.CSRFHelper.updateCSRFMeta(response);

                    if (response.success) {
                        // Update the advertisements content
                        updateAdvertisementsContent(response.html);
                        
                        // Show success message (optional)
                    } else {
                        console.error('Error sorting advertisements:', response.message);
                        showError((_t.adSortError || 'Error sorting ads') + ': ' + response.message);
                    }
                },
                error: function(xhr, status, error) {
                    console.error('Sort AJAX error details:', {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        responseText: xhr.responseText,
                        error: error
                    });
                    
                    // Always try to update CSRF token first
                    if (xhr.responseJSON && xhr.responseJSON.csrf_hash) {
                        window.CSRFHelper.updateCSRFMeta(xhr.responseJSON);
                    }
                    
                    // Try to parse response for more details
                    let errorMessage = _t.adSortError || 'Error sorting ads';
                    try {
                        if (xhr.responseText) {
                            const response = JSON.parse(xhr.responseText);
                            if (response.message) {
                                errorMessage += ': ' + response.message;
                            }
                        }
                    } catch (e) {
                        console.error('Could not parse error response:', e);
                    }
                    
                    showError(errorMessage);
                },
                complete: function(xhr) {
                    // Hide loading indicator
                    hideLoading();
                    
                    // Update CSRF token if available
                    if (xhr && xhr.responseJSON && xhr.responseJSON.csrf_hash) {
                        window.CSRFHelper.updateCSRFMeta(xhr.responseJSON);
                    }
                }
            });
        }

        // PUBLISH CONFIRMATION MODAL - Create once on page load
        if ($('#publish-confirm-modal').length === 0) {
            const modalHtml = `
                <div class="common-modal publish-confirm-modal position-fixed overflow-auto transition-default text-center" id="publish-confirm-modal">
                    <div class="common-modal-content publish-confirm-modal-content position-relative d-inline-block">
                        <a href="#" class="common-modal-cross publish-confirm-modal-closer">
                            <img src="/assets/frontend/images/modal-close.svg" alt="Close modal" class="position-absolute object-contain">
                        </a>
                        <div class="publish-confirm-modal-inner position-relative background-white default-border-radius p-4">
                            <h3 class="font-bold mb-3">${_t.publishConfirmTitle || 'Publish ad?'}</h3>
                            <p class="mb-4">${_t.publishConfirmText || 'Are you sure you want to publish this ad? The publish date will be updated.'}</p>
                            <div class="common-modal-actions">
                                <button type="button" class="default-button default-button-black publish-confirm-yes">${_t.publishConfirmYes || 'Yes, publish'}</button>
                                <button type="button" class="default-button default-button-simple publish-confirm-no">${_t.cancel || 'Cancel'}</button>
                            </div>
                        </div>
                    </div>
                </div>
            `;
            $('body').append(modalHtml);
        }
        
        // Close modal handlers (using event delegation for dynamic content)
        $(document).off('click', '.publish-confirm-modal-closer, .publish-confirm-no').on('click', '.publish-confirm-modal-closer, .publish-confirm-no', function(e) {
            e.preventDefault();
            $('#publish-confirm-modal').removeClass('active');
        });
        
        // Confirm publish handler (using event delegation)
        $(document).off('click', '.publish-confirm-yes').on('click', '.publish-confirm-yes', function(e) {
            e.preventDefault();
            const $modal = $('#publish-confirm-modal');
            const carId = $modal.data('car-id');
            const section = $modal.data('section');
            
            if (!carId) {
                console.error('Car ID not found in modal');
                return;
            }
            
            $modal.removeClass('active');
            
            // Proceed with publish
            proceedWithPublish(carId, section);
        });
        
        // PUBLISH ADVERTISEMENT FUNCTIONALITY (using event delegation for dynamically loaded content)
        profileCommonParent.on("click", ".single-advertisement-button-publish", function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            const $button = $(this);
            const $adElement = $button.closest('.single-advertisement');
            const carId = $button.data('car-id');
            
            // Get current section from active tab button
            const activeButton = $('.profile-tab-button.active-description');
            const section = activeButton.length ? activeButton.data('section') : 'active';
            
            if (!carId) {
                console.error('Car ID not found');
                return;
            }
            
            // Show publish confirmation modal
            const $modal = $('#publish-confirm-modal');
            $modal.data('car-id', carId);
            $modal.data('section', section);
            $modal.addClass('active');
        });
        
        // Function to proceed with publish after confirmation
        function proceedWithPublish(carId, section) {
            const $button = $('.single-advertisement-button-publish[data-car-id="' + carId + '"]');
            const $adElement = $button.closest('.single-advertisement');
            
            if (!$button.length) {
                console.error('Publish button not found');
                return;
            }
            
            var $content = $('.profile-common-content');

            const originalText = $button.text();
            $button.text(_t.publishing || 'Publishing...').addClass('disabled');
            $adElement.css('opacity', '0.5');
            
            // Prepare form data
            let formData = new FormData();
            formData.append('id', carId);
            formData.append('action', 'publish');
            formData.append('section', section);
            
            // csrfSafeAjaxPost will fetch fresh token and inject it automatically
            csrfSafeAjaxPost(
                getMoveAdEndpoint(),
                formData,
                function(response) {
                    if (response.success) {
                        // Remove the published advertisement element
                        $adElement.fadeOut(300, function() {
                            $(this).remove();
                            
                            // Update advertisements list if HTML provided
                            if (response.html) {
                                const $advertisementsList = $('.profile-advertisements');
                                if ($advertisementsList.length) {
                                    // Find the correct list based on section
                                    let $targetList;
                                    if (response.section === 'active') {
                                        $targetList = $('.active-advertisements-list');
                                    } else if (response.section === 'drafts') {
                                        $targetList = $('.draft-advertisements-list');
                                    } else if (response.section === 'archive') {
                                        $targetList = $('.archived-advertisements-list');
                                    }
                                    
                                    if ($targetList && $targetList.length) {
                                        $targetList.html(response.html);
                                    } else {
                                        // If list doesn't exist, reload section
                                        loadSectionContent(response.section);
                                    }
                                } else {
                                    // Reload section content
                                    loadSectionContent(response.section);
                                }
                            }
                            
                            // Update stats if provided
                            if (response.userStats) {
                                // Update active ads count
                                if (response.userStats.active_ads !== undefined) {
                                    $('.active-advertisements-sidebar-statistic .single-sidebar-statistic-value').text(response.userStats.active_ads);
                                    $('.sidebar-advertisements').text(response.userStats.active_ads);
                                }
                                
                                // Update drafts count
                                if (response.userStats.draft_ads !== undefined && response.userStats.published_draft_ads !== undefined) {
                                    const unpublishedCount = response.userStats.draft_ads - response.userStats.published_draft_ads;
                                    $('.drafts-sidebar-statistic .single-sidebar-statistic-value').text(unpublishedCount + ' / ' + response.userStats.published_draft_ads);
                                }
                                
                                // Update total views
                                if (response.userStats.total_views !== undefined) {
                                    const formattedViews = response.userStats.total_views.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                                    $('.total-views-sidebar-statistic .single-sidebar-statistic-value').text(formattedViews);
                                }
                            }
                            
                            // Show success message
                            const successMsg = $('<div class="alert alert-success mt-2">' + response.message + '</div>');
                            $('.profile-common-content').prepend(successMsg);
                            setTimeout(() => successMsg.fadeOut(() => successMsg.remove()), 5000);
                            
                            // Reload active section to show published ad
                            if (response.section === 'active') {
                                loadSectionContent('active');
                            }
                        });
                    } else if (response.phone_not_verified) {
                        $button.text(originalText).removeClass('disabled');
                        $adElement.css('opacity', '1');
                        var phoneMsg = _t.phoneNotVerified || response.message || 'Phone verification required';
                        var phoneAction = _t.phoneVerifyAction || 'Verify';
                        var verifyMsg = $('<div class="alert alert-warning mt-2"><i class="bi bi-exclamation-triangle-fill"></i> ' +
                            phoneMsg +
                            ' <a href="/profile/settings#phone-verify" class="btn btn-sm btn-warning ms-2">' + phoneAction + '</a></div>');
                        $content.prepend(verifyMsg);
                    } else {
                        // Reset button state
                        $button.text(originalText).removeClass('disabled');
                        $adElement.css('opacity', '1');
                        
                        // Show error message
                        const errorMsg = $('<div class="alert alert-danger mt-2">' + (response.message || _t.adPublishError || 'Error publishing ad.') + '</div>');
                        $content.prepend(errorMsg);
                        setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 5000);
                    }
                },
                function(xhr, status, error) {
                    console.error('Publish error:', error);
                    
                    // Reset button state
                    $button.text(originalText).removeClass('disabled');
                    $adElement.css('opacity', '1');
                    
                    // Show error message
                    let errorMessage = _t.adPublishErrorRetry || 'Error publishing ad. Please try again.';
                    try {
                        if (xhr.responseJSON && xhr.responseJSON.message) {
                            errorMessage = xhr.responseJSON.message;
                        }
                    } catch (e) {
                        console.error('Could not parse error response:', e);
                    }
                    
                    const errorMsg = $('<div class="alert alert-danger mt-2">' + errorMessage + '</div>');
                    $('.profile-common-content').prepend(errorMsg);
                    setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 5000);
                }
            );
        }

        // AD ACTION CONFIRMATION MODAL - used for move to drafts and delete actions
        if ($('#ad-action-confirm-modal').length === 0) {
            const modalHtml = `
                <div class="common-modal ad-action-confirm-modal position-fixed overflow-auto transition-default text-center" id="ad-action-confirm-modal" role="dialog" aria-modal="true" aria-labelledby="ad-action-confirm-title" aria-describedby="ad-action-confirm-text">
                    <div class="common-modal-content ad-action-confirm-modal-content position-relative d-inline-block">
                        <a href="#" class="common-modal-cross ad-action-confirm-modal-closer">
                            <img src="/assets/frontend/images/modal-close.svg" alt="Close modal" class="position-absolute object-contain">
                        </a>
                        <div class="ad-action-confirm-modal-inner position-relative background-white default-border-radius p-4">
                            <h3 class="font-bold mb-3" id="ad-action-confirm-title"></h3>
                            <p class="mb-4" id="ad-action-confirm-text"></p>
                            <div class="common-modal-actions">
                                <button type="button" class="default-button default-button-black ad-action-confirm-yes"></button>
                                <button type="button" class="default-button default-button-simple ad-action-confirm-no"></button>
                            </div>
                        </div>
                    </div>
                </div>
            `;
            $('body').append(modalHtml);
            $('#ad-action-confirm-modal .ad-action-confirm-no').text(_t.cancel || 'Cancel');
        }

        let pendingAdActionLink = null;

        function closeAdActionConfirmModal() {
            const $modal = $('#ad-action-confirm-modal');
            $modal.removeClass('active').removeData('action-link');
            pendingAdActionLink = null;
        }

        function getConfirmationText($confirmationWrapper) {
            const $textOnly = $confirmationWrapper.clone();
            $textOnly.find('a, button, script, style').remove();
            return ($textOnly.text() || '').trim();
        }

        function openAdActionConfirmModal($button) {
            const $buttonWrapper = $button.closest('.single-advertisement-button-wrapper');
            const $confirmationWrapper = $buttonWrapper.find('.delete-advertisement-wrapper').first();
            const $actionLink = $confirmationWrapper.find('.delete-advertisement').first();

            if (!$actionLink.length) {
                console.error('Ad action confirmation link not found');
                return;
            }

            const title = ($button.text() || '').trim();
            const message = getConfirmationText($confirmationWrapper) || title;
            const confirmText = ($actionLink.text() || '').trim() || _t.deleteConfirmYes || 'Yes';
            const $modal = $('#ad-action-confirm-modal');

            pendingAdActionLink = $actionLink;
            $modal.data('action-link', $actionLink);
            $modal.find('#ad-action-confirm-title').text(title);
            $modal.find('#ad-action-confirm-text').text(message);
            $modal.find('.ad-action-confirm-yes').text(confirmText);
            $modal.addClass('active');

            setTimeout(function () {
                $modal.find('.ad-action-confirm-yes').trigger('focus');
            }, 0);
        }

        $(document)
            .off('click', '.ad-action-confirm-modal-closer, .ad-action-confirm-no')
            .on('click', '.ad-action-confirm-modal-closer, .ad-action-confirm-no', function(e) {
                e.preventDefault();
                closeAdActionConfirmModal();
            });

        $(document)
            .off('click', '#ad-action-confirm-modal')
            .on('click', '#ad-action-confirm-modal', function(e) {
                if (e.target === this) {
                    closeAdActionConfirmModal();
                }
            });

        $(document)
            .off('keydown.adActionConfirm')
            .on('keydown.adActionConfirm', function(e) {
                if (e.key === 'Escape' && $('#ad-action-confirm-modal').hasClass('active')) {
                    closeAdActionConfirmModal();
                }
            });

        $(document)
            .off('click', '.ad-action-confirm-yes')
            .on('click', '.ad-action-confirm-yes', function(e) {
                e.preventDefault();
                const $link = pendingAdActionLink;
                closeAdActionConfirmModal();

                if ($link && $link.length) {
                    runAdAction($link);
                }
            });

        // DELETE ADVERTISEMENT FUNCTIONALITY
        profileCommonParent.on("click", ".single-advertisement-button-delete", function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            openAdActionConfirmModal($(this));
        });

        function runAdAction($link) {
            if (!$link || !$link.length || $link.hasClass('disabled')) {
                return;
            }

            const $adElement = $link.closest('.single-advertisement');
            const carId = $link.data('car-id');
            const action = $link.data('action'); // 'move_to_draft', 'move_to_archive', 'delete'
            const originalConfirmText = ($link.text() || '').trim() || _t.deleteConfirmYes || 'Yes';
            
            // Get current section from active tab button
            const activeButton = $('.profile-tab-button.active-description');
            const section = activeButton.length ? activeButton.data('section') : 'active';
            
            if (!carId) {
                console.error('Car ID not found');
                return;
            }
            
            // Show loading
            $link.text(_t.processing || 'Processing...').addClass('disabled');
            $adElement.css('opacity', '0.5');
            
            // Prepare form data
            let formData = new FormData();
            formData.append('id', carId);
            formData.append('action', action || 'auto');
            formData.append('section', section);
            
            // csrfSafeAjaxPost will fetch fresh token and inject it automatically
            csrfSafeAjaxPost(
                getMoveAdEndpoint(),
                formData,
                function(response) {
                    if (response.success) {
                        // Remove the deleted/moved advertisement element
                        $adElement.fadeOut(300, function() {
                            $(this).remove();
                            
                            // Update advertisements list if HTML provided
                            if (response.html) {
                                const $advertisementsList = $('.profile-advertisements');
                                if ($advertisementsList.length) {
                                    // Find the correct list based on section
                                    let $targetList;
                                    if (response.section === 'active') {
                                        $targetList = $('.active-advertisements-list');
                                    } else if (response.section === 'drafts') {
                                        $targetList = $('.draft-advertisements-list');
                                    } else if (response.section === 'archive') {
                                        $targetList = $('.archived-advertisements-list');
                                    }
                                    
                                    if ($targetList && $targetList.length) {
                                        $targetList.html(response.html);
                                    } else {
                                        // If list doesn't exist, reload section
                                        loadSectionContent(response.section);
                                    }
                                } else {
                                    // Reload section content
                                    loadSectionContent(response.section);
                                }
                            }
                            
                            // Show success message
                            const successMsg = $('<div class="alert alert-success mt-2">' + response.message + '</div>');
                            $('.profile-common-content').prepend(successMsg);
                            setTimeout(() => successMsg.fadeOut(() => successMsg.remove()), 5000);

                            // If this was a hard delete from drafts, ask what happened (sold / not sold)
                            if (response.feedback && response.feedback.token) {
                                openDeleteOutcomeModal(response.feedback);
                            }
                            
                            // If no ads left in current section, show empty state
                            const currentList = $('.active-advertisements-list, .draft-advertisements-list, .archived-advertisements-list').filter(':visible');
                            if (currentList.length && currentList.find('.single-advertisement').length === 0) {
                                // Could reload section to show empty state, or just leave it
                            }
                        });
                    } else {
                        // Reset button state
                        $link.text(originalConfirmText).removeClass('disabled');
                        $adElement.css('opacity', '1');
                        
                        const errorMsg = $('<div class="alert alert-danger mt-2">' + (response.message || _t.adActionError || 'Error processing ad.') + '</div>');
                        $('.profile-common-content').prepend(errorMsg);
                        setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 5000);
                    }
                },
                function(xhr, status, error) {
                    console.error('Move/Delete error:', error);
                    
                    // Reset button state
                    $link.text(originalConfirmText).removeClass('disabled');
                    $adElement.css('opacity', '1');
                    
                    let errorMessage = _t.adActionErrorRetry || 'Error processing ad. Please try again.';
                    try {
                        if (xhr.responseJSON && xhr.responseJSON.message) {
                            errorMessage = xhr.responseJSON.message;
                        }
                    } catch (e) {
                        console.error('Could not parse error response:', e);
                    }
                    
                    const errorMsg = $('<div class="alert alert-danger mt-2">' + errorMessage + '</div>');
                    $('.profile-common-content').prepend(errorMsg);
                    setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 5000);
                }
            );
        }

        // Handle legacy inline confirmation link if it is activated directly
        profileCommonParent.on("click", ".delete-advertisement", function (e) {
            e.preventDefault();
            runAdAction($(this));
        });

        // Hide delete confirmation when clicking outside
        profileCommonParent.on("click", function (e) {
            if (!$(e.target).closest('.single-advertisement-button-wrapper').length) {
                $('.delete-advertisement-wrapper').addClass('d-none');
                $('.single-advertisement-button-delete').removeClass('d-none');
            }
        });

        // QUICK PRICE EDIT (inline, with Save + Cancel, Enter/Esc)
        function closeAllPriceEditors() {
            $('.quick-price.is-editing').each(function() {
                const $wrap = $(this);
                if ($wrap.hasClass('is-saving')) return;
                cancelPriceEdit($wrap);
            });
        }

        function openPriceEdit($wrap) {
            if (!$wrap || !$wrap.length) return;
            if ($wrap.hasClass('is-saving')) return;

            closeAllPriceEditors();

            const raw = ($wrap.attr('data-price-raw') || '').toString();
            $wrap.find('.quick-price-input').val(raw);
            $wrap.find('.quick-price-display').addClass('d-none');
            $wrap.find('.quick-price-editor').removeClass('d-none');
            $wrap.addClass('is-editing');

            const $input = $wrap.find('.quick-price-input');
            setTimeout(function() {
                $input.trigger('focus');
                try { $input[0].select(); } catch (e) {}
            }, 0);
        }

        function cancelPriceEdit($wrap) {
            if (!$wrap || !$wrap.length) return;
            const raw = ($wrap.attr('data-price-raw') || '').toString();
            $wrap.find('.quick-price-input').val(raw);
            $wrap.find('.quick-price-editor').addClass('d-none');
            $wrap.find('.quick-price-display').removeClass('d-none');
            $wrap.removeClass('is-editing');
        }

        function showPriceError(message) {
            const text = message || quickPriceI18n.errorGeneric;
            const errorMsg = $('<div class="alert alert-danger mt-2"></div>').text(text);
            $('.profile-common-content').prepend(errorMsg);
            setTimeout(() => errorMsg.fadeOut(() => errorMsg.remove()), 5000);
        }

        function savePriceEdit($wrap) {
            if (!$wrap || !$wrap.length) return;
            if ($wrap.hasClass('is-saving')) return;

            const carId = parseInt($wrap.attr('data-car-id') || '0', 10);
            if (!carId) {
                showPriceError(quickPriceI18n.errorMissingCarId);
                return;
            }

            const inputVal = ($wrap.find('.quick-price-input').val() || '').toString().trim();
            if (!inputVal) {
                showPriceError(quickPriceI18n.errorEnterPrice);
                return;
            }

            $wrap.addClass('is-saving');
            const $input = $wrap.find('.quick-price-input');
            const $saveBtn = $wrap.find('.quick-price-save-button');
            const $cancelBtn = $wrap.find('.quick-price-cancel-button');
            const oldSaveText = $saveBtn.text();

            $input.prop('disabled', true);
            $saveBtn.prop('disabled', true).text('...');
            $cancelBtn.prop('disabled', true);

            const formData = new FormData();
            formData.append('car_id', carId);
            formData.append('price', inputVal);

            csrfSafeAjaxPost(
                getUpdatePriceEndpoint(),
                formData,
                function(response) {
                    if (response && response.success) {
                        const raw = (response.price_raw !== undefined && response.price_raw !== null)
                            ? response.price_raw.toString()
                            : inputVal;
                        const formatted = (response.price_formatted !== undefined && response.price_formatted !== null)
                            ? response.price_formatted.toString()
                            : raw;

                        $wrap.attr('data-price-raw', raw);
                        $wrap.find('.quick-price-value').text(formatted);
                        $wrap.removeClass('is-saving');

                        // Close editor
                        cancelPriceEdit($wrap);

                        // Small visual feedback
                        $wrap.addClass('quick-price-saved');
                        setTimeout(() => $wrap.removeClass('quick-price-saved'), 800);
                    } else {
                        $wrap.removeClass('is-saving');
                        showPriceError((response && response.message) ? response.message : null);
                    }
                },
                function(xhr) {
                    $wrap.removeClass('is-saving');
                    let msg = null;
                    try {
                        if (xhr && xhr.responseJSON && xhr.responseJSON.message) {
                            msg = xhr.responseJSON.message;
                        }
                    } catch (e) {}
                    showPriceError(msg);
                },
                function() {
                    $input.prop('disabled', false);
                    $saveBtn.prop('disabled', false).text(oldSaveText);
                    $cancelBtn.prop('disabled', false);
                }
            );
        }

        // Open editor
        profileCommonParent.on('click', '.quick-price-edit-button', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const $wrap = $(this).closest('.quick-price');
            openPriceEdit($wrap);
        });

        // Save / Cancel buttons
        profileCommonParent.on('click', '.quick-price-save-button', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const $wrap = $(this).closest('.quick-price');
            savePriceEdit($wrap);
        });
        profileCommonParent.on('click', '.quick-price-cancel-button', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const $wrap = $(this).closest('.quick-price');
            cancelPriceEdit($wrap);
        });

        // Enter/Esc keys
        profileCommonParent.on('keydown', '.quick-price-input', function(e) {
            const $wrap = $(this).closest('.quick-price');
            if (e.key === 'Enter') {
                e.preventDefault();
                savePriceEdit($wrap);
            } else if (e.key === 'Escape') {
                e.preventDefault();
                cancelPriceEdit($wrap);
            }
        });

        // PRICE HISTORY MODAL (dynamic loading)
        if ($('#price-history-modal').length === 0) {
            const modalHtml = `
                <div class="common-modal price-history-modal position-fixed overflow-auto transition-default text-center" id="price-history-modal">
                    <div class="common-modal-content price-history-modal-content position-relative d-inline-block">
                        <a href="#" class="common-modal-cross price-history-modal-closer">
                            <img src="/assets/frontend/images/modal-close.svg" alt="" class="position-absolute object-contain">
                        </a>
                        <div class="price-history-modal-inner position-relative background-white default-border-radius p-4">
                            <div class="d-flex align-items-center mb-3">
                                <h3 class="price-history-modal-title font-bold"></h3>
                            </div>
                            <div class="price-history-loading d-none"></div>
                            <div class="price-history-error alert alert-danger mt-2 d-none"></div>
                            <div class="price-history-empty d-none"></div>
                            <div class="price-history-list"></div>
                            <div class="price-history-footer mt-3 d-flex justify-content-center">
                                <button type="button" class="default-button default-button-black price-history-load-more d-none"></button>
                            </div>
                        </div>
                    </div>
                </div>
            `;
            $('body').append(modalHtml);

            const $modal = $('#price-history-modal');
            $modal.find('.price-history-modal-title').text(priceHistoryI18n.title);
            $modal.find('.price-history-loading').text(priceHistoryI18n.loading);
            $modal.find('.price-history-empty').text(priceHistoryI18n.empty);
            $modal.find('.price-history-load-more').text(priceHistoryI18n.loadMore);
            $modal.find('.price-history-modal-closer img').attr('alt', priceHistoryI18n.close);
        }

        function closePriceHistoryModal() {
            const $modal = $('#price-history-modal');
            $modal.removeClass('active');
        }

        // Close modal handlers
        $(document)
            .off('click', '.price-history-modal-closer')
            .on('click', '.price-history-modal-closer', function(e) {
                e.preventDefault();
                closePriceHistoryModal();
            });

        // Close when clicking on overlay
        $(document)
            .off('click', '#price-history-modal')
            .on('click', '#price-history-modal', function(e) {
                if (e.target === this) {
                    closePriceHistoryModal();
                }
            });

        // Close on ESC
        $(document)
            .off('keydown.priceHistory')
            .on('keydown.priceHistory', function(e) {
                if (e.key === 'Escape' && $('#price-history-modal').hasClass('active')) {
                    closePriceHistoryModal();
                }
            });

        function renderPriceHistoryRows($list, items) {
            if (!items || !items.length) return;

            items.forEach(function(item) {
                const direction = item && item.direction ? item.direction : 'same';
                const rowClass = direction === 'down'
                    ? 'price-history-row--down'
                    : (direction === 'up' ? 'price-history-row--up' : 'price-history-row--same');

                const $row = $('<div class="price-history-row"></div>').addClass(rowClass);
                $('<div class="price-history-date"></div>').text(item.changed_at_formatted || '').appendTo($row);

                const changeText = (item.old_formatted || '0,00') + ' € → ' + (item.new_formatted || '0,00') + ' €';
                $('<div class="price-history-change"></div>').text(changeText).appendTo($row);

                const sign = direction === 'down' ? '-' : (direction === 'up' ? '+' : '');
                const diffText = sign + (item.diff_formatted || '0,00') + ' €';
                $('<div class="price-history-diff"></div>').text(diffText).appendTo($row);

                $list.append($row);
            });
        }

        function loadPriceHistoryPage($modal, isInitialLoad) {
            if (!$modal || !$modal.length) return;
            if ($modal.data('is-loading')) return;

            const carId = parseInt($modal.data('car-id') || '0', 10);
            if (!carId) return;

            const offset = parseInt($modal.data('offset') || '0', 10) || 0;
            const limit = 10;

            $modal.data('is-loading', true);
            $modal.find('.price-history-error').addClass('d-none').text('');

            const $loadMoreBtn = $modal.find('.price-history-load-more');
            const oldBtnText = $loadMoreBtn.text();

            if (isInitialLoad) {
                $modal.find('.price-history-loading').removeClass('d-none');
                $modal.find('.price-history-empty').addClass('d-none');
                $loadMoreBtn.addClass('d-none').prop('disabled', true);
            } else {
                $loadMoreBtn.prop('disabled', true).text('...');
            }

            const formData = new FormData();
            formData.append('car_id', carId);
            formData.append('offset', offset);
            formData.append('limit', limit);

            csrfSafeAjaxPost(
                getPriceHistoryEndpoint(),
                formData,
                function(response) {
                    if (response && response.success) {
                        const items = response.items || [];
                        const $list = $modal.find('.price-history-list');

                        if (isInitialLoad) {
                            $list.empty();
                        }

                        if (items.length) {
                            renderPriceHistoryRows($list, items);
                            $modal.find('.price-history-empty').addClass('d-none');
                        } else if (isInitialLoad) {
                            $modal.find('.price-history-empty').removeClass('d-none');
                        }

                        const hasMore = !!response.has_more;
                        const nextOffset = (response.next_offset !== undefined && response.next_offset !== null)
                            ? parseInt(response.next_offset, 10)
                            : (offset + items.length);

                        $modal.data('offset', nextOffset);

                        if (hasMore) {
                            $loadMoreBtn.removeClass('d-none').prop('disabled', false).text(priceHistoryI18n.loadMore);
                        } else {
                            $loadMoreBtn.addClass('d-none');
                        }
                    } else {
                        $modal.find('.price-history-error').removeClass('d-none').text((response && response.message) ? response.message : priceHistoryI18n.error);
                    }
                },
                function(xhr) {
                    let msg = priceHistoryI18n.error;
                    try {
                        if (xhr && xhr.responseJSON && xhr.responseJSON.message) {
                            msg = xhr.responseJSON.message;
                        }
                    } catch (e) {}
                    $modal.find('.price-history-error').removeClass('d-none').text(msg);
                },
                function() {
                    $modal.data('is-loading', false);
                    $modal.find('.price-history-loading').addClass('d-none');
                    $loadMoreBtn.prop('disabled', false).text(oldBtnText || priceHistoryI18n.loadMore);
                }
            );
        }

        function openPriceHistoryModalForCar(carId) {
            const $modal = $('#price-history-modal');
            if (!$modal.length) return;

            $modal.data('car-id', carId);
            $modal.data('offset', 0);
            $modal.data('is-loading', false);

            $modal.find('.price-history-list').empty();
            $modal.find('.price-history-error').addClass('d-none').text('');
            $modal.find('.price-history-empty').addClass('d-none');
            $modal.find('.price-history-loading').removeClass('d-none');
            $modal.find('.price-history-load-more').addClass('d-none').prop('disabled', true).text(priceHistoryI18n.loadMore);

            $modal.addClass('active');

            loadPriceHistoryPage($modal, true);
        }

        // Open modal from each ad card
        profileCommonParent.on('click', '.quick-price-history-button', function(e) {
            e.preventDefault();
            e.stopPropagation();
            closeAllPriceEditors();

            const $wrap = $(this).closest('.quick-price');
            const carId = parseInt($wrap.attr('data-car-id') || '0', 10);
            if (!carId) {
                showPriceError(quickPriceI18n.errorMissingCarId);
                return;
            }

            openPriceHistoryModalForCar(carId);
        });

        // Load more
        $(document)
            .off('click', '.price-history-load-more')
            .on('click', '.price-history-load-more', function(e) {
                e.preventDefault();
                const $modal = $('#price-history-modal');
                loadPriceHistoryPage($modal, false);
            });

    });
});